import uuid from 'uuid/v4';


export default class Card {
  id = uuid('card');
  title = '';
  subtitle = '';

  constructor(src, title, subtitle) {
    this.title = title;
    this.subtitle = subtitle;
    this.src = src;
  }

  clone() {
    return new Card(this.src, this.title, this.subtitle);
  }
}
